import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=0b846c33&scoped=true&"
import script from "./photoList.vue?vue&type=script&lang=babel&"
export * from "./photoList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b846c33",
  null
  
)

export default component.exports